import { render, staticRenderFns } from "./RichtextEditor.vue?vue&type=template&id=1425edef&scoped=true"
import script from "./RichtextEditor.vue?vue&type=script&lang=js"
export * from "./RichtextEditor.vue?vue&type=script&lang=js"
import style0 from "./RichtextEditor.vue?vue&type=style&index=0&id=1425edef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1425edef",
  null
  
)

export default component.exports